import React, { createContext, useReducer } from 'react';
import { authReducer } from './authReducer';

const AuthStateContext = createContext();
const AuthDispatchContext = createContext();

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(authReducer, {
    cognitoId: null,
    email: null,
    firstTimeUser: false,
    isLoading: true,
    isSignout: false,
    userToken: null,
    userType: null,
  });

  return (
    <AuthStateContext.Provider value={state}>
      <AuthDispatchContext.Provider value={dispatch}>
        {children}
      </AuthDispatchContext.Provider>
    </AuthStateContext.Provider>
  );
}

function useAuthState() {
  const context = React.useContext(AuthStateContext);
  if (context === undefined) {
    throw new Error('useAuthState must be used within a AuthProvider');
  }
  return context;
}
function useAuthDispatch() {
  const context = React.useContext(AuthDispatchContext);
  if (context === undefined) {
    throw new Error('useAuthDispatch must be used within a AuthProvider');
  }
  return context;
}

export { AuthProvider, useAuthState, useAuthDispatch };
